module.exports = __webpack_public_path__ + "img/oxygen_pool_villa.ba61f000.jpg";